import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Marca Corona Color Palette approximations based on Pantone 2738 C and Cool Grays
// Primary Blue (Reference: Pantone 2738 C )
const marcaBlue = {
    50: '#eef2ff',
    100: '#e0e7ff',
    200: '#c7d2fe',
    300: '#a5b4fc',
    400: '#7186f5', // Adjusted tint to align with Pantone 2738 C hue
    500: '#1a33c0', // Lighter tint derived from Pantone 2738 C
    600: '#001e96', // Brand Primary — Pantone 2738 C (corrected)
    700: '#001877',
    800: '#00135d',
    900: '#000c3d',
    950: '#00061a'
};

// Surface Cool Grays (Reference: Pantone Cool Gray 4C/427C )
const marcaGray = {
    0: '#ffffff',
    50: '#f7f7f8', // Very light, akin to RAL 9002 [cite: 189]
    100: '#edeeef',
    200: '#dfe1e2', // Pantone 427 C range
    300: '#c6c7c8', // Pantone Cool Gray 4 C range
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
    950: '#030712'
};

export const MarcaCoronaPreset = definePreset(Aura, {
    semantic: {
        primary: marcaBlue,
        colorScheme: {
            light: {
                surface: marcaGray,
                primary: {
                    color: '{primary.600}',
                    inverseColor: '#ffffff',
                    hoverColor: '{primary.700}',
                    activeColor: '{primary.800}'
                },
                text: {
                    color: '{surface.800}', // Deep gray for text legibility
                    hoverColor: '{surface.900}',
                    mutedColor: '{surface.500}'
                }
            },
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '{surface.950}',
                    100: '{surface.900}',
                    200: '{surface.800}',
                    300: '{surface.700}',
                    400: '{surface.600}',
                    500: '{surface.500}',
                    600: '{surface.400}',
                    700: '{surface.300}',
                    800: '{surface.200}',
                    900: '{surface.100}',
                    950: '{surface.50}'
                }
            }
        },
        // Typography Configuration [cite: 215, 217]
        fontFamily: '"Inter", "Segoe UI", sans-serif', // Primary UI font
    },
});
